import { Text } from "@ecco/ui/text";
import { Flex } from "@ecco/ui/flex";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { type FC } from "react";

interface Props {
    usps?: { key: string; text: string | React.ReactNode }[];
}

export const ProsList: FC<Props> = ({ usps = [] }) => {
    if (usps.length === 0) return null;

    return (
        <>
            {usps.map(
                ({ key, text }) =>
                    text && (
                        <Flex key={key} gap={1} my={2} alignItems="flex-start" flexWrap="nowrap">
                            <ECCOIcon name="ok" size="md" aria-hidden="true" flexShrink={0} />
                            <Text
                                fontWeight="semibold"
                                fontSize={["mobileBodyTextSmall", "desktopBodyTextSmall"]}
                                whiteSpace="normal"
                                wordBreak="break-word"
                                flex="1"
                            >
                                <span data-microcopy-key={key}>{text}</span>
                            </Text>
                        </Flex>
                    )
            )}
        </>
    );
};
